import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'parentheses', 'Parentheses', [["path",{"d":"M7 4a12.25 12.25 0 0 0 0 16"}],["path",{"d":"M17 4a12.25 12.25 0 0 1 0 16"}]]);